import mutations from './../mutations';
import api from '../../api';

export default {
  namespaced: true,
  state: {
    loading: false,
    budgets: [],
    status: null
  },
  mutations: {
    [mutations.LOADING](state) {
      state.loading = true;
    },
    [mutations.LOADED](state) {
      state.loading = false;
    }
  },
  actions: {
    parseAddCutBudget({ commit }, payload) {
      commit(mutations.LOADING);
      return api.budgetDynamic
        .parseAddCutBudget(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    parseAddBudget({ commit }, payload) {
      commit(mutations.LOADING);
      return api.budgetDynamic
        .parseAddBudget(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    submitAddCutBudget({ commit }, payload) {
      commit(mutations.LOADING);
      return api.budgetDynamic
        .submitAddCutBudget(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    },
    createBulk({ commit }, payload) {
      commit(mutations.LOADING);
      return api.budgetDynamic
        .createBulk(payload)
        .then(({ data }) => {
          commit(mutations.LOADED);
          return data;
        })
        .catch(error => {
          commit(mutations.LOADED);
          console.log(error);
          return error;
        });
    }
  },
  getters: {}
};
